import capitalize from "underscore.string/capitalize";

export default {
  methods: {
    capitalize: (str) => capitalize(str),
  },
};
